import Vue from 'vue'
import { ToastPlugin, ModalPlugin, IconsPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import VueDraggable from 'vuedraggable'
import VueTheMask from 'vue-the-mask'
import InfiniteLoading from 'vue-infinite-loading'

import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import VueVirtualScroller from 'vue-virtual-scroller'
import router from './router'
import store from './store'
import App from './App.vue'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import { eventBus } from '@/libs/event-bus'
import vModelCustom from '@/directives/model-custom'

// Quill modules
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ImageUpload from '@/plugins/quill-image'
import PhotoArchiveInsert from '@/plugins/quill-photo-archive-insert'
import PhotoArchiveFormat from '@/plugins/quill-photo-archive-format'
import PhotoShortcodeBlot from '@/plugins/quill-photo-shortcode-blot'
import PhotoShortcodePreview from '@/plugins/quill-photo-shortcode-preview'
import { defaultQuillOptions } from '@/plugins/quill-config'
import VueQuillEditor from 'vue-quill-editor/src'

window.Quill = Quill

const icons = Quill.import('ui/icons')
icons['photo-archive'] = '<svg viewBox="0 0 18 18"><rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect><circle class="ql-fill" cx="7" cy="8" r="1.5"></circle><polyline class="ql-stroke" points="5 12 8 9 11 11 14 8"></polyline></svg>'

Quill.register(PhotoArchiveFormat)
Quill.register(PhotoShortcodeBlot)
Quill.register('modules/imageUpload', ImageUpload)
Quill.register('modules/photoArchiveInsert', PhotoArchiveInsert)
Quill.register('modules/photoShortcodePreview', PhotoShortcodePreview)
Vue.use(VueQuillEditor, defaultQuillOptions)

momentDurationFormatSetup(moment)
moment.locale('ru')
Vue.prototype.$moment = moment
Vue.prototype.$eventBus = eventBus

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueDraggable)
Vue.use(VueTheMask)
Vue.use(IconsPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.use(VueVirtualScroller)

Vue.use(Vuesax)

Vue.directive('model-custom', vModelCustom)

Vue.use(InfiniteLoading, {
  slots: {
    // keep default styles
    noResults: '',
    // remove default styles
    noMore: '',
  },
})
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
